/**
 * @author Leonel Martinez
 * @module Spinner
 * @fileoverview `Vuex spinner module`
 * @see Spinner.vue
 */
import i18n from "@/i18n";
export const spinner = {
  namespaced: true,
  state: {
    active: false,
    message: i18n.tc("LoadingSpinner.DefaultMessage")
  },
  actions: {
    /**
     * @description Toggles the state and set a message
     * @param {boolean} active Boolean
     * @param {string} message String
     */
    TOGGLE_SPINNER: ({ commit }, { active, message }) => {
      commit('SET_SPINNER_STATE', { active, message });
    }
  },
  mutations: {
    /**
     * @description Mutates the spinner state and message
     * @param {boolean} active Boolean
     * @param {string} message String
     */
    SET_SPINNER_STATE: (state, { active, message }) => {
      state.active = active
      if (message) state.message = message
    }
  }
};
